import { combineReducers } from 'redux';
import { coreOrganizationsAllGetAsyncSlice } from './get';
import { coreOrganizationsAllRemoveSyncSlice } from './remove';
import { coreOrganizationsAllUpdateSyncSlice } from './update';
import { combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';

export const coreOrganizationsAllReducers = combineReducers({
	get: joinCollectionReducers([
		coreOrganizationsAllGetAsyncSlice.asyncReducers,
		coreOrganizationsAllUpdateSyncSlice.syncReducer,
		coreOrganizationsAllRemoveSyncSlice.syncReducer
	], coreOrganizationsAllGetAsyncSlice.asyncState)
});

export const coreOrganizationsAllWatchers = combineAllWatchers([
	coreOrganizationsAllGetAsyncSlice.asyncWatchers
]);
